import initializeAttachments from './initializeAttachments';
import type AttachmentWellViewState from '../../schema/AttachmentWellViewState';
import type { AttachmentMenuAction } from 'owa-attachment-full-data';
import type { MailboxInfo } from 'owa-client-ids';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { action } from 'satcheljs/lib/legacy';

/**
 * This clears the previous attachments in the attachment well and reinitialized it with the new set of attachments
 * @param attachments - the attachments to be hosted in the attachment well
 * @param mailboxInfo - the mailbox info used for the client attachment id
 * @param attachmentWell - the view state for this attachment well
 * @param forceUpdateAttachmentsInStore - whether to update the existing attachment in the store
 * @param unsupportedMenuActions - The list of unsupported menu actions for the attachments
 */
export default action('reinitializeAttachments')(function reinitializeAttachments(
    attachments: AttachmentType[],
    mailboxInfo: MailboxInfo,
    attachmentWell: AttachmentWellViewState,
    forceUpdateAttachmentsInStore: boolean,
    unsupportedMenuActions?: AttachmentMenuAction[]
): void {
    // If attachments is null, we don't need to do anything
    if (!attachments) {
        return;
    }

    // Clear the previous state of attachments
    attachmentWell.docViewAttachments = [];
    attachmentWell.imageViewAttachments = [];
    attachmentWell.inlineAttachments = [];
    attachmentWell.isInitialized = false;

    // Initialize the attachments again
    initializeAttachments(
        attachments,
        mailboxInfo,
        attachmentWell,
        forceUpdateAttachmentsInStore,
        false /* isInitializationForCompose */,
        unsupportedMenuActions
    );
});
